module.exports = __webpack_public_path__ + "static/media/photo_004.9798a510.JPG";